import { PropsWithChildren, useEffect } from 'react'
import { IMentionsSuggestionsListProps } from './MentionsSuggestionsList'
import { Box } from '@material-ui/core'
import { StyledEllipsisBox, StyledTaggable } from './styled'
import { useTheme } from 'styled-components'
import { truncateValues } from 'common/utils/truncateValues'
import { findHashtag } from 'common/utils/findHashtag'

export interface ITaggingResultListProps extends IMentionsSuggestionsListProps { }

export const TaggingResultList = (props: PropsWithChildren<ITaggingResultListProps>) => {
  const theme = useTheme()

  const {
    tagResults,
    shouldUpdateTextfield,
    value: html,
    mentionedCounter,
    setText,
    setTags,
    resetMentioningRef,
    hashCount,
    autoTag,
    setAutoTag,
  } = props

  const id = `tags-suggestions-list`

  useEffect(() => {
    if (autoTag) {
      const target = document.getElementById(id).firstChild

      if (target) {
        // @ts-ignore
        target.click()
      }

      setAutoTag(false)
    }
  }, [autoTag])

  return (
    <Box id={id}>
      {tagResults
        .filter(item => !!item)
        .map(tag => (
          <StyledTaggable
            key={tag?.tagId}
            style={{
              cursor: 'pointer',
              color: theme.colors.accent1
            }}
            onClick={event => {
              const triggerChar = '#'
              if (shouldUpdateTextfield ?? true) {
                const value = html

                const index = findHashtag(hashCount, value)

                const hashPos = index
                const query =
                  mentionedCounter > 0 ? value.slice(hashPos, hashPos + mentionedCounter + 1) : triggerChar

                const aTag = `#${tag.topic}`

                const newTitle = value.slice(hashPos)
                  .replace(
                    query,
                    `${aTag}&nbsp;`
                  )

                const newValue = value?.slice(0, hashPos).concat(newTitle)

                setText(newValue)
              } else {
                setText('')
              }


              setTags(prev => {
                prev?.set(tag.topic, tag)

                return new Map(prev)
              })

              resetMentioningRef?.current()
            }}
          >
            <Box width="calc(100% - 2rem)" paddingLeft="1rem" paddingRight="1rem" boxSizing="border-box">
              <StyledEllipsisBox>#{tag?.topic}</StyledEllipsisBox>
              <StyledEllipsisBox fontSize={'0.625rem'} color={theme.colors.accent}>
                {tag?.totalTopicCount && `${truncateValues(tag?.totalTopicCount)} Posts`}
              </StyledEllipsisBox>
            </Box>
          </StyledTaggable>
        ))}
    </Box>
  )
}
